// Mock data for Loranrix.com portfolio
// This will be replaced by JSON API in backend integration

export const siteData = {
  fr: {
    hero: {
      title: "Je crée des applications web et mobiles",
      titleHighlight: "modernes et scalables",
      subtitle: "Développeur full-stack spécialisé dans les architectures haute performance et les expériences utilisateur exceptionnelles",
      cta1: "Voir mes projets",
      cta2: "Mes services",
      cta3: "Me contacter",
      availabilityBadge: "Disponible en freelance"
    },
    about: {
      title: "Architecte de solutions digitales",
      description: "Je conçois des systèmes digitaux complets, optimisés pour la performance et la scalabilité. Avec une expertise en React, Node.js, et architectures cloud, je transforme vos idées en produits digitaux qui performent.",
      skills: [
        { name: "React / Next.js", level: 95 },
        { name: "Node.js / FastAPI", level: 92 },
        { name: "Architecture Cloud", level: 90 },
        { name: "Mobile (Capacitor)", level: 88 },
        { name: "UX Engineering", level: 93 }
      ],
      stats: [
        { number: "50+", label: "Projets livrés" },
        { number: "5+", label: "Années d'expérience" },
        { number: "100%", label: "Satisfaction client" }
      ]
    },
    services: [
      {
        id: "web-dev",
        title: "Développement Web Sur Mesure",
        description: "Applications web modernes avec React, performances optimales et UX exceptionnelle",
        icon: "code",
        features: ["React / Next.js", "API REST / GraphQL", "Responsive Design", "Performance optimisée"]
      },
      {
        id: "mobile",
        title: "Applications Mobiles",
        description: "Apps cross-platform avec Capacitor pour iOS et Android depuis une base de code unique",
        icon: "smartphone",
        features: ["iOS & Android", "Performance native", "Offline-first", "Push notifications"]
      },
      {
        id: "backend",
        title: "Architecture Backend",
        description: "APIs scalables, systèmes temps réel et architectures cloud robustes",
        icon: "server",
        features: ["Node.js / Python", "Redis / PostgreSQL", "Microservices", "Cloud deployment"]
      },
      {
        id: "ux",
        title: "UX Engineering",
        description: "Interfaces intuitives avec animations premium et micro-interactions engageantes",
        icon: "palette",
        features: ["Design systems", "Animations avancées", "Accessibilité", "Tests utilisateurs"]
      }
    ],
    pricing: [
      {
        id: "starter",
        name: "Starter",
        price: "2500",
        currency: "EUR",
        period: "projet",
        description: "Parfait pour les petits projets et MVP",
        features: [
          "Site vitrine ou landing page",
          "Design responsive",
          "3 révisions incluses",
          "Livraison en 2-3 semaines",
          "Support 30 jours"
        ],
        cta: "Démarrer",
        popular: false
      },
      {
        id: "pro",
        name: "Pro",
        price: "8500",
        currency: "EUR",
        period: "projet",
        description: "Applications web complètes et scalables",
        features: [
          "Application web full-stack",
          "Backend API personnalisé",
          "Intégrations tierces",
          "Révisions illimitées",
          "Livraison en 6-8 semaines",
          "Support 90 jours",
          "Formation incluse"
        ],
        cta: "Commencer",
        popular: true
      },
      {
        id: "premium",
        name: "Premium",
        price: "Sur devis",
        currency: "",
        period: "",
        description: "Systèmes complexes et architectures d'entreprise",
        features: [
          "Architecture sur mesure",
          "Microservices & scalabilité",
          "Systèmes temps réel",
          "DevOps & CI/CD",
          "Support prioritaire",
          "Consulting inclus"
        ],
        cta: "Discutons-en",
        popular: false
      }
    ],
    contact: {
      title: "Travaillons ensemble",
      subtitle: "Un projet en tête ? Discutons-en autour d'un café (virtuel ou réel)",
      email: "contact@loranrix.com",
      formLabels: {
        name: "Nom",
        email: "Email",
        project: "Parlez-moi de votre projet",
        submit: "Envoyer"
      }
    },
    footer: {
      copyright: "© 2025 Loranrix. Tous droits réservés.",
      tagline: "Conçu avec précision et passion"
    }
  },
  en: {
    hero: {
      title: "I build modern and scalable",
      titleHighlight: "web & mobile applications",
      subtitle: "Full-stack developer specialized in high-performance architectures and exceptional user experiences",
      cta1: "View projects",
      cta2: "Services",
      cta3: "Contact me",
      availabilityBadge: "Available for freelance"
    },
    about: {
      title: "Digital Solutions Architect",
      description: "I design complete digital systems optimized for performance and scalability. With expertise in React, Node.js, and cloud architectures, I transform your ideas into high-performing digital products.",
      skills: [
        { name: "React / Next.js", level: 95 },
        { name: "Node.js / FastAPI", level: 92 },
        { name: "Cloud Architecture", level: 90 },
        { name: "Mobile (Capacitor)", level: 88 },
        { name: "UX Engineering", level: 93 }
      ],
      stats: [
        { number: "50+", label: "Projects delivered" },
        { number: "5+", label: "Years of experience" },
        { number: "100%", label: "Client satisfaction" }
      ]
    },
    services: [
      {
        id: "web-dev",
        title: "Custom Web Development",
        description: "Modern web applications with React, optimal performance and exceptional UX",
        icon: "code",
        features: ["React / Next.js", "REST / GraphQL APIs", "Responsive Design", "Optimized performance"]
      },
      {
        id: "mobile",
        title: "Mobile Applications",
        description: "Cross-platform apps with Capacitor for iOS and Android from a single codebase",
        icon: "smartphone",
        features: ["iOS & Android", "Native performance", "Offline-first", "Push notifications"]
      },
      {
        id: "backend",
        title: "Backend Architecture",
        description: "Scalable APIs, real-time systems and robust cloud architectures",
        icon: "server",
        features: ["Node.js / Python", "Redis / PostgreSQL", "Microservices", "Cloud deployment"]
      },
      {
        id: "ux",
        title: "UX Engineering",
        description: "Intuitive interfaces with premium animations and engaging micro-interactions",
        icon: "palette",
        features: ["Design systems", "Advanced animations", "Accessibility", "User testing"]
      }
    ],
    pricing: [
      {
        id: "starter",
        name: "Starter",
        price: "2500",
        currency: "EUR",
        period: "project",
        description: "Perfect for small projects and MVPs",
        features: [
          "Showcase or landing page",
          "Responsive design",
          "3 revisions included",
          "Delivery in 2-3 weeks",
          "30-day support"
        ],
        cta: "Get started",
        popular: false
      },
      {
        id: "pro",
        name: "Pro",
        price: "8500",
        currency: "EUR",
        period: "project",
        description: "Complete and scalable web applications",
        features: [
          "Full-stack web application",
          "Custom backend API",
          "Third-party integrations",
          "Unlimited revisions",
          "Delivery in 6-8 weeks",
          "90-day support",
          "Training included"
        ],
        cta: "Start now",
        popular: true
      },
      {
        id: "premium",
        name: "Premium",
        price: "Custom quote",
        currency: "",
        period: "",
        description: "Complex systems and enterprise architectures",
        features: [
          "Custom architecture",
          "Microservices & scalability",
          "Real-time systems",
          "DevOps & CI/CD",
          "Priority support",
          "Consulting included"
        ],
        cta: "Let's talk",
        popular: false
      }
    ],
    contact: {
      title: "Let's build something together",
      subtitle: "Have a project in mind? Let's discuss it over coffee (virtual or real)",
      email: "contact@loranrix.com",
      formLabels: {
        name: "Name",
        email: "Email",
        project: "Tell me about your project",
        submit: "Send"
      }
    },
    footer: {
      copyright: "© 2025 Loranrix. All rights reserved.",
      tagline: "Crafted with precision & passion"
    }
  },
  siteMeta: {
    documentTitleFr: "Loranrix — Portfolio développeur full-stack",
    documentTitleEn: "Loranrix — Full-stack developer portfolio",
  },
  socials: {
    instagram: "https://instagram.com/loranrix",
    facebook: "https://facebook.com/loranrix",
    linkedin: "https://linkedin.com/in/loranrix",
    github: "https://github.com/loranrix",
    youtube: "",
    tiktok: ""
  }
};

// Fallback si l’API /projects est indisponible — aligné sur backend/data/projects.json
export const projectsData = [
  {
    id: 'gwada-pulse',
    title: 'GWADA Pulse',
    description: {
      fr: "Super-app Guadeloupe : carte et vie locale en temps réel, annonces, événements, Pass Gwada, météo, messagerie et apps iOS/Android — Next.js, WebSocket, files d’attente, prod sur VPS.",
      en: 'Guadeloupe super-app: real-time map and local life, classifieds, events, Gwada Pass, weather, messaging, iOS/Android apps — Next.js, WebSocket, job queues, VPS production.',
    },
    category: 'Web & mobile',
    tech: ['Next.js', 'React', 'MariaDB', 'Redis', 'Capacitor'],
    image: '/projects/gwadapulse.jpg',
    year: '2025',
    link: 'https://gwadapulse.com',
    featured: true,
  },
  {
    id: 'domtom-annonces',
    title: 'DomTom Annonces',
    description: {
      fr: 'Petites annonces multi-îles pour les DOM-TOM : publication rapide, cartes, filtres, favoris et vitrines SEO — Next.js, MariaDB, déploiement sur VPS.',
      en: 'Multi-island classifieds for French overseas territories: fast posting, maps, filters, favorites and SEO-friendly listings — Next.js, MariaDB, VPS hosting.',
    },
    category: 'Marketplace',
    tech: ['Next.js', 'Prisma', 'MariaDB', 'Cloudflare'],
    image: '/projects/domtomannonces.png',
    year: '2025',
    link: 'https://domtomannonces.com',
    featured: true,
  },
  {
    id: 'pizza-square',
    title: 'Pizza Square',
    description: {
      fr: 'Plateforme pizza pro : recettes, calculateurs, annonces emploi/matériel, guides et app mobile — Next.js, Postgres, Docker, prod sur VPS.',
      en: 'Pro pizza platform: recipes, calculators, job/equipment listings, guides and mobile app — Next.js, Postgres, Docker, VPS production.',
    },
    category: 'Web & mobile',
    tech: ['Next.js', 'Postgres', 'Prisma', 'Docker', 'Flutter'],
    image: '/projects/pizzasquare.png',
    year: '2025',
    link: 'https://pizzasquare.fr',
    featured: true,
  },
  {
    id: 'le-tipster-fou',
    title: 'Le Tipster Fou',
    description: {
      fr: 'Site de pronostics VIP : sélection auto, stats, Telegram, abonnements Stripe et admin — Next.js, Postgres, Redis, Docker sur VPS.',
      en: 'VIP tipster platform: auto picks, stats, Telegram, Stripe subscriptions and admin — Next.js, Postgres, Redis, Docker on VPS.',
    },
    category: 'SaaS',
    tech: ['Next.js', 'Postgres', 'Redis', 'Stripe', 'Docker'],
    image: '/projects/tipsterfou.png',
    year: '2025',
    link: 'https://letipsterfou.fr',
    featured: true,
  },
];
